export default {
  OPEN_IMPORTANT_NOTIFICATION_DIALOG: 'OpenImportantNotificationDialog',
  CLOSE_IMPORTANT_NOTIFICATION_DIALOG: 'CloseImportantNotificationDialog',
  LOAD_IMPORTANT_NOTIFICATION_DIALOG_NOTIFICATION_START: 'LoadImportantNotificationDialogNotificationStart',
  LOAD_IMPORTANT_NOTIFICATION_DIALOG_NOTIFICATION_END: 'LoadImportantNotificationDialogNotificationEnd',
  UPDATE_IMPORTANT_NOTIFICATION_DIALOG_NOTIFICATION_CONFIRM_START: 'UpdateImportantNotificationDialogNotificationConfirmStart',
  UPDATE_IMPORTANT_NOTIFICATION_DIALOG_NOTIFICATION_CONFIRM_END: 'UpdateImportantNotificationDialogNotificationConfirmEnd',
  UPDATE_IMPORTANT_NOTIFICATION_DIALOG_NOTIFICATION_READ_START: 'UpdateImportantNotificationDialogNotificationReadStart',
  UPDATE_IMPORTANT_NOTIFICATION_DIALOG_NOTIFICATION_READ_END: 'UpdateImportantNotificationDialogNotificationReadEnd'
};
